define([
    'common/ui/view/svg/index',
    'common/ui/view/svg/util',
    'common/ui/template/svg/grid.hbs'
], function(
    SVGView,
    SVGUtil,
    Grid
    ) {
    var GridView = SVGView.extend({
        tagName: 'g',
        className: 'grid',

        initialize: function(params) {
            GridView.__super__.initialize.call(this, {});
            this.width = params.width;
            this.height = params.height;
        },

        render: function() {
            this.$el
                .style('pointer-events', 'none')
                .style('opacity', 0);

            if(this.getOption('includeDefs')) {
                this.$el.append('defs').html(Grid());
            }

            this.$el
                .append('rect')
                .attr('width', this.width)
                .attr('height', this.height)
                .attr('transform', SVGUtil.transform({
                    x: - this.width / 2,
                    y: - this.height / 2
                }))
                .style('fill', 'url(#large-grid)')
                .style('stroke', 'none');

            this.$el
                .append('rect')
                .attr('width', this.width)
                .attr('height', this.height)
                .attr('transform', SVGUtil.transform({
                    x: - this.width / 2,
                    y: - this.height / 2
                }))
                .style('fill', 'url(#small-grid)')
                .style('stroke', 'none');

            return this;
        },

        show: function() {
            this.$el
                .style('opacity', 1);
        },

        hide: function() {
            this.$el
                .style('opacity', 0);
        }
    });

    return GridView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/grid.js